<script>
import Drawer from "@/components/drawer";
import Swal from "sweetalert2";
import VLazyImage from "v-lazy-image/v2";

// Custom Components
import PageHeader from "@/components/page-header";
import UserService from "@/helpers/APIService/user.service";
import Building from "@/components/inventory/building.vue";
import Middleware from "@/helpers/middlewares";
import errorHandler from "@/helpers/errorHandler";
import { authComputed } from "@/state/helpers";
import appConfig from "@/app.config";

// Building section Component
export default {
  page: {
    title: "Building Section",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Drawer,
    Building,
    PageHeader,
    VLazyImage,
  },
  data() {
    return {
      title: "Building",

      isLoading: true,
      editable: true,
      isDragging: false,
      table: {
        tableData: [],
      },
      openBuildingDrawer: false,
      selectedBuilding: null,
      submitted: null,
      isEdit: false,
    };
  },
  computed: {
    ...authComputed,

    buildingProps() {
      return {
        selectedBuilding: this.selectedBuilding,
        isEdit: this.isEdit,
      };
    },
  },
  mounted() {
    // this.getBuildingListData();
    this.$root.$on("updateImageStatusInBuilding", (data) => {
      this.manageImageResponse(data, "updateImageStatusInBuilding");
    });
    this.$root.$on("imageAddedInBuilding", (data) => {
      this.manageImageResponse(data, "imageAddedInBuilding");
    });
    this.$root.$on("removeImageInBuilding", (data) => {
      this.manageImageResponse(data, "removeImageInBuilding");
    });
  },
  methods: {
    async getBuildingListData() {
      await UserService.getBuildingList()
        .then((building) => {
          this.table.tableData = building;
          this.isLoading = false;
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    buildingForm() {
      if (this.openBuildingDrawer == true) {
        this.selectedBuilding = null;
        this.isEdit = false;
      }
      this.openBuildingDrawer = !this.openBuildingDrawer;
    },
    // Method is use for update live data
    buildingAddedUpdated(building) {
      if (this.isEdit == true) {
        this.table.tableData = this.table.tableData.map((item) => {
          if (item.id === building.id) {
            item = building;
          }
          return item;
        });
        Middleware.notification("Successfully updated !!", "success");
      } else {
        this.table.tableData.unshift(building);
        Middleware.notification("Successfully added !!", "success");
      }
      this.buildingForm();
    },
    saveAndAddNewBuilding(building) {
      this.table.tableData.unshift(building);
      Middleware.notification("Successfully added !!", "success");
    },
    // Method is use for update building based on ID
    edit(data) {
      this.selectedBuilding = data;
      this.isEdit = true;
      this.buildingForm();
    },
    // Method is use for delete building
    deleteBuilding(index, id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          UserService.deleteBuilding(id).then(
            () => {
              this.table.tableData.splice(index, 1);
              Middleware.notification("Successfully deleted !!", "warning");
            },
            (error) => {
              errorHandler(error);
            }
          );
        }
      });
    },
    // Method is used to manage drawer action response
    manageImageResponse(data, status) {
      this.table.tableData = this.table.tableData.map((item) => {
        if (item.id == data.building) {
          if (status == "updateImageStatusInBuilding") {
            item.building_image = item.building_image.map((img) => {
              if (img.id == data.id) {
                img.is_thumbnail = true;
              } else {
                img.is_thumbnail = false;
              }
              return img;
            });
          }
          if (status == "removeImageInBuilding") {
            item.building_image = item.building_image.filter(
              (img) => img.id !== data.id
            );
          }
        }
        return item;
      });
    },
  },
};
</script>

<template>
  <div>
    <PageHeader
      :title="title"
      :action="buildingForm"
      text="Add New Building"
      :isButton="true"
    />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12 mt-2">
                <div class="table-responsive mb-0">
                  <!-- Table -->
                  <table
                    class="table table-hover mb-0 common-table"
                    ref="my-table"
                    v-infinite-scroll="getBuildingListData"
                    infinite-scroll-disabled="busy"
                    infinite-scroll-distance="10"
                  >
                    <thead class="table-light">
                      <tr>
                        <th>Name</th>
                        <th>Short Name</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody v-if="isLoading">
                      <tr v-for="(item, index) in 20" :key="index">
                        <td class="placeholder-glow" v-for="no in 3" :key="no">
                          <span class="placeholder w-100 placeholder-lg"></span>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr v-for="(data, index) in table.tableData" :key="index">
                        <td @click="edit(data)">
                          <!-- <div class="d-flex align-items-center"> -->
                          <template v-for="image in data.building_image">
                            <v-lazy-image
                              v-if="image.is_thumbnail"
                              :key="image.id"
                              :src="image.image.replace('upload', 'thumbs200')"
                              alt=""
                              class="rounded-circle picture-img"
                            />
                          </template>
                          <img
                            v-if="data.building_image.length == 0"
                            key="image"
                            src="@/assets/images/placeholder.png"
                            alt=""
                            class="rounded-circle picture-img"
                          />

                          <span class="text-truncate ms-2 w-75">{{
                            data.name
                          }}</span>
                          <!-- </div> -->
                        </td>
                        <td @click="edit(data)">
                          {{ data.short_name }}
                        </td>
                        <td>
                          <div slot="actions" class="d-flex align-items-center">
                            <i
                              class="fas fa-pencil-alt text-success me-2"
                              v-b-popover.hover="'Edit building'"
                              @click="edit(data)"
                            ></i>
                            <i
                              v-b-popover.hover="'Delete building'"
                              class="mdi mdi-trash-can fs-5 text-danger"
                              @click="deleteBuilding(index, data.id)"
                            ></i>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-if="!isLoading && table.tableData.length == 0">
                      <tr>
                        <td colspan="9" class="text-center">
                          <img
                            src="@/assets/images/empty.svg"
                            class="img-fluid"
                            alt=""
                          />
                          <p>
                            <span class="text-secondary">No Data Found</span>
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Drawer is for add and update new building -->
    <Drawer
      @close="buildingForm"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
    >
      <div v-if="openBuildingDrawer">
        <Building
          :currentProps="buildingProps"
          @submitted="buildingAddedUpdated"
          @cancelSubmit="buildingForm"
          @saveAndAddNew="saveAndAddNewBuilding"
        />
      </div>
    </Drawer>
  </div>
</template>
